// extracted by mini-css-extract-plugin
module.exports = {"root":"BindsForm_root__3FCPw","body":"BindsForm_body__23ZSE","selectList":"BindsForm_selectList__vcIyl","footer":"BindsForm_footer__10V8j"};